import { useEffect, useState } from 'react';
import instance from '../api/axios/utils.ts/instance';
import { ApiResponse } from '../constants/types';

// 커뮤니티 링크 (노출 순서대로 내려온다)
export interface CommunityLink {
  id: number;
  name: string;
  description: string | null;
  linkUrl: string;
  iconImageUrl: string | null;
}

// 조회 실패 또는 빈 응답일 때 사용하는 기본 링크 (어드민 등록 데이터 기준, 이미지는 로컬)
const FALLBACK_LINKS: CommunityLink[] = [
  {
    id: -1,
    name: '주일학교 교사 카페',
    description: '여러 교회와 함께해요!',
    linkUrl: 'https://cafe.naver.com/jcebs',
    iconImageUrl: process.env.PUBLIC_URL + 'images/course/churchschool.png',
  },
  {
    id: -2,
    name: '영어교실 교사 카페',
    description: '선생님들과 함께해요!',
    linkUrl: 'https://cafe.naver.com/jemm',
    iconImageUrl: process.env.PUBLIC_URL + 'images/course/homeschool.png',
  },
];

// 헤더(PC/모바일)와 페이지가 동시에 써도 한 번만 호출한다. 실패하면 다음 마운트 때 재시도.
let request: Promise<CommunityLink[]> | null = null;

const fetchLinks = () => {
  if (!request) {
    request = instance
      .get<ApiResponse<CommunityLink[]>>('/v1/community-links')
      .then(({ data }) => data.data ?? [])
      .catch((err) => {
        request = null;
        throw err;
      });
  }
  return request;
};

/**
 * 노출 중인 커뮤니티 링크 목록 조회
 * 조회가 끝났는데 목록이 비어 있으면 기본 링크로 폴백한다.
 */
export const useCommunityLinks = () => {
  const [links, setLinks] = useState<CommunityLink[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    fetchLinks()
      .then((data) => {
        if (alive) setLinks(data);
      })
      .catch((err) => console.error('커뮤니티 링크 조회 실패', err))
      .finally(() => {
        if (alive) setLoading(false);
      });

    return () => {
      alive = false;
    };
  }, []);

  return { links: !loading && !links.length ? FALLBACK_LINKS : links, loading };
};
